import { render, staticRenderFns } from "./license-card.vue?vue&type=template&id=54c48aab&"
import script from "./license-card.vue?vue&type=script&lang=js&"
export * from "./license-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports